/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LangInput = "de" | "en" | "es" | "fr" | "it";
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsSEOLinks_place$ref: FragmentReference;
declare export opaque type AggregatesListingsSEOLinks_place$fragmentType: AggregatesListingsSEOLinks_place$ref;
export type AggregatesListingsSEOLinks_place = {|
  +type: TypeOfPlace,
  +neighbouringAlternatives: $ReadOnlyArray<{|
    +label: string,
    +inLabel: string,
    +type: TypeOfPlace,
    +slug: string,
    +lang: LangInput,
  |}>,
  +innerAlternatives: $ReadOnlyArray<{|
    +label: string,
    +inLabel: string,
    +type: TypeOfPlace,
    +slug: string,
    +lang: LangInput,
  |}>,
  +$refType: AggregatesListingsSEOLinks_place$ref,
|};
export type AggregatesListingsSEOLinks_place$data = AggregatesListingsSEOLinks_place;
export type AggregatesListingsSEOLinks_place$key = {
  +$data?: AggregatesListingsSEOLinks_place$data,
  +$fragmentRefs: AggregatesListingsSEOLinks_place$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inLabel",
    "storageKey": null
  },
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lang",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsSEOLinks_place",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "neighbouringAlternatives",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "innerAlternatives",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Place",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e498d5f524e994426b5ba9e15f438227';

export default node;
